import { enableHistorySync, NuqsAdapter } from 'nuqs/adapters/react';
import type { FunctionComponent, PropsWithChildren } from 'react';

enableHistorySync();

// No defaultOptions here: the tile-specific throttle/shallow options are applied
// via withOptions in UrlTileProvider, so other useQueryState consumers under
// this adapter keep nuqs defaults.
export const UrlTileQueryAdapter: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <NuqsAdapter>{children}</NuqsAdapter>
);
